<div class="container-fluid animated fadeIn">
	<div class="row flex-column align-items-center my-5">
		<!-- STEPS TITLE -->
		<div class="col-12 mb-4">
			<div class="wiz-title text-center">
				{{ 'document-upload-step1.pageTitle' | translate }}
			</div>
		</div>

		<!-- CARD -->
		<div class="col-12 col-xl-8">
			<eif-custom-stepper
				[steps]="steps"
				[currentStep]="currentStep">
			</eif-custom-stepper>

			<div class="simple-card top-line">
				<div class="row justify-content-center px-3 py-3 px-md-5 py-md-5">
					<div class="col-12">
						<div class="modal-wrapper">
							<eif-contracts-in-company
								[uploadContractType]="uploadContractType"
								[initialCompanyId]="companyId"
								[initialContractId]="fileRelatedContractId"
								(companyChange)="onCompanyChange($event)"
								(contractChange)="onContractChange($event)"
								(validationChange)="onValidationChange($event)">
							</eif-contracts-in-company>
						</div>
					</div>
				</div>
			</div>

			<div class="d-flex align-items-center justify-content-between">
				<div class="d-flex flex-grow-1">
					<a
						role="button"
						class="is-color-primary"
						(click)="openInstructionsModal()">
						<i class="fa-solid fa-info-circle me-2"></i>
						<span>{{ 'document-upload-step1.howToUpload' | translate }}</span>
					</a>
				</div>
				<!-- BUTTONS AREA -->
				<div class="d-flex align-items-center justify-content-xs-center justify-content-end py-4 gap-3">
					<eif-custom-button
						[text]="'button.cancel' | translate"
						[color]="'neutral'"
						(action)="redirectToDocuments()">
					</eif-custom-button>
					@if (hasEnteredRequiredData()) {
						<eif-custom-button
							[text]="'document-upload-step1.goToUploadStep' | translate"
							(action)="redirectToDocumentsStep2()">
						</eif-custom-button>
					}
				</div>
			</div>
		</div>
	</div>
</div>
